import { IPlot } from "@interfaces/IPlot";
import { GeocodeService } from "@services/geocode.service";
import { TranslationService } from "@services/translation.service";

export function geocodeFilter(geocodeService: GeocodeService, translationService: TranslationService) {
    return (plot: IPlot, isLatLng: boolean) => {

        const failureString = translationService.t('resourceGeofences.FailedToGetLocation');
        if (!plot || !plot.LocationInformation) {
            return "N/A";
        }

        let locationString = plot.LocationInformation.LocationDescription;

        if (!locationString) {

            locationString = translationService.t('Common.Updating') + "...";

            geocodeService
                .getLocationInformationFromPlotId(plot.Id)
                .then(location => {
                    plot.LocationInformation = location;
                    locationString = plot.LocationInformation.LocationDescription;
                })
                .catch(() => {
                    locationString = failureString;
                });
        }

        return locationString;
    };
}
